import { useEffect, useState } from "react"


import { useFirebase } from "@meddbriefer/mdb-firebase"
import { getScenarioTypeObject } from "@meddbriefer/scenario-data/index.js";

import { updateSchema } from "./traumaScenario"

import SetScenarioNameForm from "./SetScenarioNameForm";

export default function CloneScenario(props) {
    const {db} = useFirebase()
    const {scenarioId} = props.match.params
    const [scenario, setScenario] = useState(null)

    useEffect(() => {
        (async () => {
            const doc = await db.collection("scenarios").doc(scenarioId).get()
            const scenData = doc.data()
            const scenTypeData = await getScenarioTypeObject(db, scenData.scenarioType, scenData.schemaVersion)
            delete scenData.id
            delete scenData.name
            setScenario(updateSchema(scenData, scenTypeData))
        })()
    }, [db, scenarioId])

    return (
        <div>
        {scenario
            ? <SetScenarioNameForm scenario={scenario} isTemplate={true} />
            : <div>loading...</div>
        }
        </div>
    )
}